import { Text } from 'slate';

/**
 * Determine if a node only contains an empty text node so we
 * can correctly serialize a trailing break just like slate does
 * in its leaf node:
 * https://github.com/aha-app/slate/blob/0-47-merged-backports/packages/slate-react/src/components/leaf.js#L89
 * @param {<import('slate').Node>} Node that represents the current block
 */
function isLineBreak(node) {
  if (node.children.length === 1) {
    const child = node.children[0];
    if (Text.isText(child) && child.text === '') return true;
  }
  return false;
}

export default isLineBreak;
